/**
 * Statement Note Utility
 *
 * Resolves the appropriate statement note (PayPal or Credit Card) from window.config.
 * These notes are HTML strings that inform the user how the charge will appear on their statement.
 *
 * Old implementation: processing_status_utils.js → renderStatementMessage()
 */

/**
 * Get the statement note HTML string based on payment method type.
 *
 * Statement notes come from window.config and contain HTML (e.g., links, formatting).
 * Returns undefined if the config values are not available.
 *
 * @param isCreditCard - Whether the payment method is a credit card (vs PayPal)
 * @returns HTML string for the statement note, or undefined if not configured
 */
export const getStatementNote = (isCreditCard: boolean): string | undefined => {
  try {
    const { config } = window as any;
    const { paypalStatementNote, creditCardStatementNote } = config || {};

    if (!paypalStatementNote || !creditCardStatementNote) {
      return undefined;
    }

    return isCreditCard ? creditCardStatementNote : paypalStatementNote;
  } catch {
    return undefined;
  }
};
